import LegalShell, { LegalSection } from "@/components/LegalShell";
import { CONTACT } from "@/lib/site";

export default function CGV() {
  return (
    <LegalShell testid="cgv" title="Conditions générales de vente">
      <LegalSection n="01" title="Objet et champ d'application">
        <p>
          Les présentes conditions régissent les prestations de réparation de smartphones, tablettes et ordinateurs, les opérations de rachat de
          matériel et les ventes d'appareils réalisées par MAXREVIX (entreprise individuelle de Maxime Cros), atelier situé à 74800
          Saint-Pierre-en-Faucigny. Toute commande ou dépôt d'appareil vaut acceptation sans réserve des présentes CGV.
        </p>
      </LegalSection>

      <LegalSection n="02" title="Diagnostic et devis">
        <p>
          Le diagnostic en atelier est facturé <strong className="text-white">29 €</strong>, intégralement déduits du montant de la réparation si
          vous la réalisez chez MAXREVIX. Le devis est gratuit, sans engagement, et toujours confirmé avant toute intervention : aucun travail
          n'est engagé sans votre accord explicite.
        </p>
        <p>
          Les tarifs indicatifs affichés sur le site sont donnés à titre d'information ; le prix définitif est celui du devis, selon le modèle
          exact et la disponibilité des pièces.
        </p>
      </LegalSection>

      <LegalSection n="03" title="Prix">
        <p>
          Les prix s'entendent en euros, TTC, pose professionnelle incluse. Deux gammes de pièces sont proposées selon votre budget : pièces
          premium (meilleur rapport qualité/prix) ou pièces d'origine / OEM. Le choix de la gamme est explicité au devis, sans surprise.
        </p>
      </LegalSection>

      <LegalSection n="04" title="Délais d'intervention">
        <p>
          Les réparations courantes (écran, batterie, connecteur de charge, caméra) sont le plus souvent réalisées en 30 à 60 minutes, sous vos
          yeux. Les pannes profondes (micro-soudure, désoxydation) peuvent demander 24 à 72 heures ; un délai précis vous est annoncé avant de
          commencer.
        </p>
      </LegalSection>

      <LegalSection n="05" title="Paiement">
        <p>
          Le règlement s'effectue à l'enlèvement de l'appareil, en espèces, par carte bancaire ou par paiement mobile. Aucun acompte n'est requis
          pour les réparations courantes ; le solde est dû uniquement après réparation validée par vos soins.
        </p>
      </LegalSection>

      <LegalSection n="06" title="Garantie">
        <p>
          Les réparations bénéficient d'une garantie <strong className="text-white">1 an pièces et main d'œuvre</strong> : si le même problème
          revient dans ce délai, nous le reprenons sans frais. Cette garantie ne couvre pas une nouvelle casse, une oxydation ultérieure, ni une
          intervention d'un tiers sur notre réparation.
        </p>
        <p>
          Les pièces vendues seules et les appareils reconditionnés bénéficient des garanties légales applicables (garantie légale de
          conformité et garantie des vices cachés).
        </p>
      </LegalSection>

      <LegalSection n="07" title="Responsabilité et données de l'appareil">
        <p>
          Nous prenons le plus grand soin de vos données et ne consultons rien sans nécessité. Nous vous recommandons toutefois de réaliser une
          sauvegarde complète avant de nous confier votre appareil : MAXREVIX ne saurait être tenue responsable de la perte de données non
          sauvegardées, ni d'une impossibilité de réparer liée à l'état initial de l'appareil (appareil précédemment ouvert, oxydation ancienne,
          pièces de qualité inconnue).
        </p>
      </LegalSection>

      <LegalSection n="08" title="Rachat de matériel">
        <p>
          L'estimation en ligne est indicative, calée sur les prix de reprise du marché. L'offre ferme est établie après contrôle de l'appareil en
          atelier (environ 2 minutes) : état, fonctionnalités, verrouillages. En cas d'acceptation, le paiement est immédiat. Aucun rachat
          d'appareil non conforme ou d'origine inconnue ne sera réalisé.
        </p>
      </LegalSection>

      <LegalSection n="09" title="Litiges et médiation">
        <p>
          Les présentes CGV sont soumises au droit français. En cas de litige, une solution amiable sera toujours recherchée en priorité :{" "}
          <a className="font-semibold text-neon hover:underline" href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a> ·{" "}
          <a className="font-semibold text-neon hover:underline" href={CONTACT.phoneHref}>{CONTACT.phoneDisplay}</a>. Le client consommateur peut
          ensuite recourir gratuitement au médiateur de la consommation dont relève MAXREVIX (article L612-1 du code de la consommation) —
          coordonnées du médiateur : [à compléter].
        </p>
      </LegalSection>
    </LegalShell>
  );
}
